import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { SettlementStatisticsConverterDetailRevenuePage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterDetailRevenuePage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * 歳入コード振り結果の検索パラメータスキーマ
 */
export const revenueSearchSchema = paginationSchema.extend({
  query_store_id: z.string().optional(),
  amount_unit: z.enum(amountUnitValues).optional(),
});

/**
 * 決算統計コンバーター結果詳細ルート（歳入コード振り結果タブ）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/revenue',
)({
  component: () => <SettlementStatisticsConverterDetailRevenuePage />,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: revenueSearchSchema,
      defaultValues: undefined,
    }),
});
